export default {
    'do-you-want-to-merge-the-region-with-another-region':  'هل تريد دمج المنطقة مع منطقة أخرى؟',
    'do-you-want-to-merge-the-area-with-another-area': '',
    'provinces': 'محافظات', 
    'cities': 'مدن',
    'areas': 'قطاعات',
    'regions': 'مناطق',
    'city': 'مدينة',
    'area': 'قطاع',
    'region': 'منطقة',
    'province': 'محافظة',
    'merge-regions': 'دمج المناطق',
    'merge-areas': '',
    'areas-in-regions': '',
    'regions-in-area': 'المناطق في الناحية',
    'please-select-a-city': 'رجاء اختر مدينة',
    'no-regions-in-this-city': 'لا يوجد مناطق في المدينة',
    'areas-in-this-city': '',
    'show-regions': 'عرض المناطق',
    'show-areas': '',
    'show-cities': 'عرض المدن',
}